import localDataFunctions from "@/localDataFunctions";
import axios from 'axios';

export default {
  name: "EnquiriesToolsCustDetails",
  mixins: [localDataFunctions],
  data: function () {
    return {
      enqIcons: {
        customFields: {
          icon: "tune",
          label: this.$t("enquiriesAccount.CustomFields"), //Custom Fields
        },
        general: {
          icon: "account_box",
          label: this.$t("enquiriesCustomerDetails.general"), //general
        },
        details: {
          icon: "manage_accounts",
          label: this.$t("enquiriesCustomerDetails.details"), //details
        },
        applications: {
          icon: "apps",
          label: this.$t("enquiriesCustomerDetails.applications"), //applications
        },
        comments: {
          icon: "chat",
          label: this.$t("enquiriesCustomerDetails.comments"), //comments
        },
        attachments: {
          icon: "attachment",
          label: this.$t("enquiriesCustomerDetails.attachments"), //attachments
        },
        images: {
          icon: "image",
          label: this.$t("enquiriesCustomerDetails.images"), //images
        },
        detailChanges: {
          icon: "settings_applications",
          label: this.$t("enquiriesCustomerDetails.detailchanges"), //detail changes
        },
        connection: {
          label: this.$t("enquiries.connection"), //connection
          icon: "cable",
        },
        subConnections: {
          label: this.$t("enquiries.subConnections"), //sub connections
          icon: "leak_add",
        },
        debtManagement: {
          icon: "credit_card",
          label: this.$t("enquiries.debitManagement"), //debt management
        },
        deposits: {
          icon: "payments",
          label: this.$t("enquiriesCustomerDetails.deposits"), //deposits
        },
        readings: {
          icon: "speed",
          label: this.$t("enquiries.readings"), //readings
        },
        meter: {
          label: this.$t("enquiriesConnectionDetails.meter"), //meter
          icon: "gas_meter",
        },
        plots: {
          label: this.$t("enquiriesCustomerDetails.plots"), //plots
          icon: "signal_cellular_alt",
        },
        transactions: {
          icon: "credit_card",
          label: this.$t("enquiriesCustomerDetails.transactions"), //transactions
        },
        unbilledTransactions: {
          icon: "credit_card_off",
          label: this.$t("enquiries.unbilledTransactions"), //unbilled transactions
        },
        statements: {
          icon: "summarize",
          label: this.$t("enquiriesCustomerDetails.statements"), //statements
        },
        settings: {
          icon: "settings",
        },
        linkedAccounts: {
          icon: "link",
          label: this.$t("enquiriesCustomerDetails.portalaccount"), //prtal linked account
        },
        linkedProperties: {
          icon: "other_houses",
          label: this.$t("enquiriesCustomerDetails.linkedProp"), //portal represented linked properties
        },
        sms: {
          icon: "sms",
          label: this.$t("enquiriesCustomerDetails.sms"), //sms
        },
        engineering: {
          icon: "engineering",
          label: this.$t("enquiriesPropertyDetails.engineering"), //engineering
        },
        owners: {
          label: this.$t("enquiriesPropertyDetails.owners"),
          icon: "group",
        },
        discounts: {
          label: this.$t("enquiriesPropertyDetails.discounts"),
          icon: "percent",
        },
        history: { icon: "history", label: this.$t("enquiries.history") },
        consumption: { icon: "trending_up" },
        barChart: { icon: "bar_chart" },
        address: { icon: "contact_mail" },
        gpsPin: { icon: "location_on" },
        other: { icon: "" },
        property: { icon: "home" },
        log: { icon: "book" },
        operations: { icon: "replay" },
        signature: { icon: "draw" },
        pie: { icon: "pie_chart" },
        alert: { icon: "warning" },
        info: { icon: "info" },
        person: { icon: "person" },
        dots: { icon: "more_horiz" },
        account: { icon: "account_circle" },
        cases: { icon: "cases" },
        agreement: { icon: "handshake" },
        investigation: { icon: "travel_explore" },
        dottedHouse: { icon: "other_houses" },
        openLocation: { icon: 'location_on' },
        tableChart: { icon: 'table_chart' }
      },
      tabs: {},
      settings: {},

      propId: '',
      custkey: '',
      selectedTab: '',
      isDetLoading: true,
      isStatementsExpanded: false,
      isReadingsExpanded: false,
      isApplicationsExpanded: false,
      isDmExpanded: false,
      isHistoryExpanded: false,
      customerDisplayInfo: {},
      menuVisible: true,
      lang: '',
    };
  },
  created() {
    this.propId = this.$route.params.propertyId;
    this.custkey = this.$route.params.custkey;

    this.tabs = [
      {
        id: "general",
        show: true,
        ...this.enqIcons.general,
      },
      {
        id: "details",
        show: true,
        ...this.enqIcons.details,
      },
      {
        id: "postaladdress",
        label: this.$t("enquiriesCustomerDetails.postaladdress"),
        show: true,
        icon: this.enqIcons.address.icon,
      },
      {
        id: "other",
        label: this.$t("enquiriesCustomerDetails.other"),
        show: true,
        icon: this.enqIcons.dots.icon,
      },
      {
        id: "plots",
        show: false,
        ...this.enqIcons.plots
      },
      {
        id: "comments",
        show: true,
        ...this.enqIcons.comments,
      },
      {
        id: "history",
        show: true,
        ...this.enqIcons.history
      },

      {
        id: "applications",
        show: true,
        ...this.enqIcons.applications
      },
      {
        id: "ownedProperties",
        show: true,
        label: this.$removeAccents(this.$t('enquiriesCustomerDetails.ownedProp')),
        icon: this.enqIcons.property.icon,
      },
      {
        id: "eventLog",
        show: true,
        label: this.$removeAccents(this.$t('enquiriesCustomerDetails.eventLog')),
        icon: this.enqIcons.log.icon,
      },
      {
        id: "deposits",
        show: true,
        ...this.enqIcons.deposits
      },
      {
        id: "dmCases",
        show: true,
        ...this.enqIcons.debtManagement
      },
      {
        id: "attachments",
        show: true,
        ...this.enqIcons.attachments
      },
      {
        id: "images",
        show: true,
        ...this.enqIcons.images
      },
      {
        id: "operations",
        show: true,
        label: this.$t('enquiriesCustomerDetails.operations'),
        icon: this.enqIcons.operations.icon
      },
      {
        id: "detailchanges",
        show: true,
        ...this.enqIcons.detailChanges
      },
      {
        id: "statements",
        show: true,
        ...this.enqIcons.statements
      },
      {
        id: "transactions",
        show: true,
        ...this.enqIcons.transactions
      },
      {
        id: "digitalSignature",
        label: this.$t("enquiriesCustomerDetails.digitalsign"),
        show: true,
        icon: this.enqIcons.signature.icon,
      },
      {
        id: "portalLinks",
        show: true,
        ...this.enqIcons.linkedAccounts
      },
      {
        id: "linkedProperties",
        show: true,
        ...this.enqIcons.linkedProperties
      },
      {
        id: "sms",
        show: true,
        ...this.enqIcons.sms
      },
      {
        id: "customFields",
        show: true,
        ...this.enqIcons.customFields
      },
      {
        id: "survaydata",
        label: this.$t("enquiriesCustomerDetails.survaydata"),
        show: false,
        icon: this.enqIcons.pie.icon
      },
      {
        id: "alert",
        label: this.$t("enquiriesCustomerDetails.alert"),
        show: false,
        icon: this.enqIcons.alert.icon
      },
    ];

    this.getCustomerDisplayInfo();
    this.getSettings();
  },
  mounted() {
    this.goToDefaultTab();

    if (this.init)
      this.init();
  },
  computed: {
    tabsToDisplay: function () {
      return this.tabs.filter(t => t.id != 'general') ?? [];
    }
  },
  methods: {
    toggleMenu(saveLocation) {
      this.menuVisible = !this.menuVisible;
      this.saveToLocal(saveLocation, this.menuVisible);
    },
    toolbarAction(item) {
      console.log("toolbarAction", item);
    },
    tabSelected(id) {
      if (Array.isArray(id)) {
        let flag = false;
        id.forEach((i) => {
          if (i == this.selectedTab)
            flag = true;
        });

        return flag ? "selected-tab-icon" : "";
      }

      if (id == this.selectedTab)
        return "selected-tab-icon";
      else
        return;
    },

    openNewWindow(path) {
      window.open(window.location.origin + path);
    },
    openReadingsDetails(event) {
      let routeData = this.$router.resolve({
        name: 'readingDetails', params: {
          ConnectionId: event.data.connectionId,
          MeterId: event.data.meterId,
          ReadingNo: event.data.readingNo
        }
      });
      window.open(routeData.href, '_blank');
    },
    openMeterDetailsCustomer(event) {
      console.log("eee", event)
      return;
      let routeData = this.$router.resolve({
        name: 'customer', params: {
          //custkey: custKey,
          MeterId: event.data.meterId,
          ReadingNo: event.data.readingNo
        }
      });
      window.open(routeData.href, '_blank');
    },
    openMeterDetails(event, tab) {
      let routeData = this.$router.resolve({ name: 'meterDetails', params: { MeterId: event.data.meterId } });
      tab = tab ? '/tab/' + tab : '';
      window.open(routeData.href + tab, '_blank');
    },

    goToDefaultTab(defaultTab) {      
      let path = this.$route.fullPath.toLowerCase();
      let tab = path.split('/')[2];

      this.tabs.forEach(obj => {
        if (obj.id.toLowerCase() == tab) {
          this.selectedTab = obj.id;
        }
      });
    },

    changeUrlLink(val) {
      if (!val)
        return;

      //console.log("path", this.$route)
     
      let fullPath = this.$route.fullPath;
      let hasDash = fullPath.substring(fullPath.length - 1, fullPath.length) == '/'

      if (!hasDash)
        fullPath = fullPath + '/';

      let urlArr = fullPath.split('/');
      urlArr[2] = encodeURIComponent(val);

      let url = urlArr.join('/');
      history.pushState({}, null, url);   
    },
    goToPage(page) {
      let flag = false;
      this.pagesLoaded.forEach(p => {
        if (p == page)
          flag = true;
      })

      //we change tab
      if (flag) {
        this.selectedTab = page;
        return;
      }

      let url = `/customerDetails/${page}/${this.custkey}/`;

      if (this.propId)
        url = url + `${this.propId}/`;

      this.$router.push(url)
    },
    getDataFailed(e) {
      if (e) {
        if (e.response && e.response.data)
          console.error(e.response.data);

        console.error(e);
      }

      this.$oldAlertMsg('Data Not Found', 4);

      if (this.loading)
        this.loading = false;

        //TBI
      //setTimeout(() => {
      //  this.$router.push('/login');
      //}, 1000);
    },

    getSettings() {
      axios.post('/Utility/GetSettings')
        .then(response => {
          if (response.status == 200) {
            this.settings = response.data.value;
          }
        })
        .catch(e => {
          //this.tabs.Connections.show = false;
          //this.tabs.Readings.show = false;
        })
    },
    changeSelectedTab(idx) {
      this.selectedTab = idx;
    },

    //grid page change
    gridPageChange(pInfo) {
      if (!pInfo || !this.selectedTab || !this[this.selectedTab])
        return;

      let selectedPinfo = this[this.selectedTab].pageingOption;
      if (selectedPinfo.page == pInfo.pageNumber && selectedPinfo.pageSize == pInfo.pageSize)
        return;

      this[this.selectedTab].pageingOption.page = pInfo.pageNumber;
      this[this.selectedTab].pageingOption.pageSize = pInfo.pageSize;

      
      if (this.selectedTab == 'ownedProperties')
        this.fillOwnedProperties(false);
      else if (this.selectedTab == 'deposits')
        this.fillOwnedProperties(false);
      else if (this.selectedTab == 'dmCases')
        this.fillDmCases(false);

      else if (this.selectedTab == 'statements')
        this.fillStatements(false);
      else if (this.selectedTab == 'detailchanges')
        this.fillDetailsChanges(false);
      else if (this.selectedTab == 'operations')
        this.fillOperations(false);
        
      else if (this.selectedTab == 'portalLinks')
        this.fillPortalLinks(false);
      else if (this.selectedTab == 'digitalSignature')
        this.fillDigitalSignature(false);
      else if (this.selectedTab == 'transactions')
        this.fillTransactions(false);
      else if (this.selectedTab == 'linkedProperties')
        this.fillLinkedProperties(false);
      else if (this.selectedTab == 'sms')
        this.fillSms(false);
    },

    getCustomerDisplayInfo() {
      this.customerDisplayInfo = null;

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/GetCustomerDisplayInfo', parameters)
        .then(response => {
          //console.log('response', response);
          if (response.data.data.status == 0) {
            this.customerDisplayInfo = response.data.custData;
          }
          else {
            this.customerDisplayInfo = null;
          }
        })
        .catch(e => {
          this.customerDisplayInfo = null;
        })
        .finally(() => {
          this.isDetLoading = false;
        });
    },  

    getIcon(item) {
      return this.tabs.filter(t => t.id == item)[0].icon;
    },
  },
};
